/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { ConditionType, ConditionTypeLabel } from "pages/thermography/model/enumerations/condition-type.model";
import { CONDITION_STYLE } from "pages/thermography/Utils";

type Props = {
    condition: ConditionType;
    className?: string;
};

export default function ConditionTag({ condition, className }: Props) {
    const cfg = CONDITION_STYLE[condition];
    const Icon = cfg.Icon;

    return (
        <span
            className={className}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "2px 8px",
                borderRadius: 6,
                background: cfg.background,
                color: cfg.color,
                fontSize: 11,
                fontWeight: 600,
                border: `1px solid ${cfg.border}`,
                whiteSpace: "nowrap"
            }}
            title={ConditionTypeLabel[condition]}
        >
            {ConditionTypeLabel[condition]}
            <Icon size={16} color={cfg.color} />
        </span>
    );
}